/**
 * Cache configuration constants
 * Centralized place for all cache-related settings
 */
export const CACHE_CONFIG = {
  DEFAULT_DURATION: 5 * 60 * 1000, // 5 minutes
  INVALIDATE_AFTER_MUTATIONS: true,
} as const;

/**
 * Module-specific cache settings
 * Better for when you have multiple cached modules
 */
export const GSP_MODULE_CACHE_CONFIG = {
  DURATION: 15 * 60 * 1000, // 15 minutes
  INVALIDATE_AFTER_MUTATIONS: true,
  ENABLE_GROUPED_CACHE: true,
} as const;